import { isFn, isPlainObject, deepClone } from '../utils';

export class Control {
  constructor(initialState) {
    this._initialState = isPlainObject(initialState) ? initialState : {};
    this._state = deepClone(this._initialState);
    this._observes = new Set();
    this._methods = {
      setValue: this._setValue,
      setState: this._setState,
      getState: this._getState,
      getValue: this._getValue,
      reset: this._reset,
    };
  }

  _notify = () => {
    this._observes.forEach((cb) => {
      if (isFn(cb)) {
        cb(this._state);
      }
    });
  };

  subscribe = (cb) => {
    this._observes.add(cb);
    return () => this._observes.delete(cb);
  };

  _setValue = (key, value) => {
    const newValue = isFn(value) ? value(this._state[key]) : value;
    this._state[key] = newValue;
    this._notify();
  };

  _setState = (values) => {
    const newValues = isFn(values) ? values(this._state) : values;
    Object.assign(this._state, newValues);
    this._notify();
  };

  _reset = (values) => {
    const newState = isFn(values) ? values(this._state) : values;
    this._state = newState ?? deepClone(this._initialState);
    this._notify();
  };

  _getState = () => {
    return this._state;
  };

  _getValue = (key) => {
    return typeof key === 'string'
      ? this._state[key]
      : key.map((k) => this._state[k]);
  };

  get methods() {
    return this._methods;
  }
}
